import OrderCURModule from "@/modules/OrderCUR";

function ViewRecordPage() {
  return <OrderCURModule type="view" />;
}

export default ViewRecordPage;
